export default __webpack_public_path__ + "static/media/landscape2.ed94d667.jpg";